import { Col } from 'reactstrap'
import { H5, LI, P, UL } from '../../../../../../AbstractElements'
import { SearchResultInitialState } from '../../../../../../Types/SearchResultType'
import { Href } from '../../../../../../Utils/Constants'

export default function BlogBox({ allResult }: SearchResultInitialState) {
    return (
        <Col xxl={6} xl={6} className="box-col-12 mt-4">
            {allResult &&
                allResult.slice(2, 6).map((item) => (
                    <div className='info-block' key={item.id}>
                        <a href={Href}>{item.url}</a>
                        <H5>{item.title}</H5>
                        <P>{item.detail}</P>
                        <div className='star-ratings'>
                            <UL className='simple-list flex-row search-info flex-wrap'>
                                <LI>
                                    <i className='icofont icofont-ui-rating'></i>
                                    <i className='icofont icofont-ui-rating'></i>
                                    <i className='icofont icofont-ui-rating'></i>
                                    <i className='icofont icofont-ui-rate-blank'></i>
                                    <i className='icofont icofont-ui-rate-blank'></i>
                                </LI>
                                <LI>{item.star}</LI>
                                <LI>{item.vote}</LI>
                                <LI>{item.news}</LI>
                            </UL>
                        </div>
                    </div>
                ))
            }
        </Col>
    )
}
